import React from 'react';
import { Form, Select, Space } from 'antd';
import { useWarehouseGroups } from 'shared/hooks/use-warehouse-groups';
import { COMPLEX_STATUS_OPTIONS } from 'types/cargo';
import { STATUS_TYPE_LABELS } from './constants';
import type { ICargoComplexStatusFilterProps } from './types';

export const CargoComplexStatusFilter: React.FC<ICargoComplexStatusFilterProps> = (props) => {
  const { statusTypeName, warehouseName, className, handleSuccess, disabled = false } = props;

  const { groups, isLoading } = useWarehouseGroups();

  return (
    <Space direction='vertical' size='small' className={className} style={{ width: '100%' }}>
      <Form.Item name={statusTypeName} style={{ marginBottom: 0 }}>
        <Select placeholder='Status type' mode='multiple' disabled={disabled} allowClear onChange={handleSuccess}>
          {COMPLEX_STATUS_OPTIONS.map((status) => (
            <Select.Option key={status} value={status}>
              {STATUS_TYPE_LABELS[status]}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name={warehouseName} style={{ marginBottom: 0 }}>
        <Select
          placeholder='Warehouse'
          mode='multiple'
          disabled={disabled}
          loading={isLoading}
          optionFilterProp='label'
          allowClear
          showSearch
          onChange={handleSuccess}>
          {groups.map((group) => (
            <Select.Option key={group.value} value={group.value} label={group.label}>
              {group.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Space>
  );
};
